import React from "react";
import { PATHS } from "@constants/Paths";
import { useNavigate } from "react-router-dom";
import { LogOutV2 as LogoutIcon } from "@piiqtechnologies/svg-icons";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import NavigationListItem from "./NavigationListItem";
import { useAuthContext } from "@stores/AuthContext";
import { ANALYTICS_DB_NAME, useAnalytics } from "@piiqtechnologies/ui-lib";
export const Logout = ({ expanded }) => {
    const navigate = useNavigate();
    const intl = useIntl();
    const { onLogout } = useAuthContext();
    const analytics = useAnalytics();
    const doLogout = () => {
        sessionStorage.clear();
        indexedDB.deleteDatabase(ANALYTICS_DB_NAME);
        onLogout();
        analytics.track("Logout");
        navigate(PATHS.LOGIN, { replace: true });
    };
    return (React.createElement(NavigationListItem, { Icon: () => React.createElement(LogoutIcon, { width: "2em", height: "2em" }), active: false, label: intl.formatMessage(messages.signOut), expanded: expanded, onClick: doLogout }));
};
export default Logout;
